import useCombinedRefs from '@swarm/core/hooks/dom/useCombinedRefs'
import useInputValidity from '@swarm/core/hooks/dom/useInputValidity'
import MaxInput, {
  CustomNumericFormat,
  MaxInputProps,
  MaxInputViewProps,
} from '@swarm/ui/swarm/MaxInput'
import { forwardRef, useMemo, useRef } from 'react'
import { Button, Flex } from 'rimble-ui'
import styled from 'styled-components/macro'

const InputWrapper = styled(Flex)`
  flex: 1 1 180px;
  min-width: 80px;
  align-items: center;
  justify-content: flex-end;
  padding-right: 12px;

  & > input {
    font-size: 16px;
    border: none;
    text-align: right;
    flex-grow: 1;
    min-width: 0;
    -moz-appearance: textfield;
    outline: none;
    width: 100%;
  }
`

const StakeAmountInputView = forwardRef<HTMLInputElement, MaxInputViewProps>(
  (
    {
      onFocus,
      onBlur,
      onChange,
      disabled,
      onMaxClick,
      reportError,
      endAdornment,
      showMax = true,
      min,
      error,
      value,
      ...props
    }: MaxInputViewProps,
    forwardedRef,
  ) => {
    const innerRef = useRef(null)
    const ref = useCombinedRefs<HTMLInputElement>(innerRef, forwardedRef)

    const handleOnFocus = useInputValidity(
      ref,
      useMemo(
        () =>
          reportError
            ? {
                error,
                value: value?.toString(),
                onFocus,
              }
            : {},
        [error, onFocus, reportError, value],
      ),
    )

    return (
      <InputWrapper>
        <CustomNumericFormat
          defaultValue={min}
          onFocus={handleOnFocus}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          disabled={disabled}
          ref={ref}
          {...props}
        />
        {endAdornment}
        {showMax && (
          <Button.Text
            size="small"
            fontWeight={5}
            p={0}
            mx={2}
            onClick={onMaxClick}
          >
            MAX
          </Button.Text>
        )}
      </InputWrapper>
    )
  },
)

StakeAmountInputView.displayName = 'StakeAmountInputView'

const StakeAmountInput = ({ ...props }: Omit<MaxInputProps, 'View'>) => {
  return <MaxInput {...props} View={StakeAmountInputView} />
}

export default StakeAmountInput
